import React, { useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid2 as Grid,
  IconButton,
  Select,
  TextField,
  Typography,
  useTheme,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import MenuItem from '@mui/material/MenuItem'
import useCustomStyles from '../../hooks/CustomStylesHook'
import Colors from '../../utils/colors.json'
import { ReactComponent as FirstAidIcon } from '../../assets/icons/FirstAid.svg'
import { ReactComponent as TieIcon } from '../../assets/icons/Tie.svg'
import { DIALOG_CATEGORIES } from '../../constants/constants'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { LocalizationProvider, DateCalendar } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs, { Dayjs } from 'dayjs'
import EditIcon from '@mui/icons-material/Edit'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const styles = (theme: any) => ({
  dialogCloseBtn: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  dialogActions: {
    justifyContent: 'center',
  },
  categoryBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    border: `1px solid ${Colors.TEXT_COLOR_QUATERNARY}`,
    borderRadius: '20px',
    padding: 20,
    textTransform: 'capitalize',
    color: Colors.TEXT_COLOR_QUATERNARY,
  },
  categorySvgContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${Colors.TEXT_COLOR_QUATERNARY}`,
    borderRadius: '50%',
    padding: 10,
  },
  categoryBtnSelected: {
    background: Colors.BTN_BG,
    color: Colors.TEXT_COLOR_MAIN,
  },
  categorySvgContainerSelected: {
    border: 'unset !important',
    background: `${Colors.WHITE_BACKGROUND} !important`,
  },
  actionBtn: {
    textTransform: 'capitalize',
    background: theme.palette.primary.main,
    borderRadius: '20px',
  },
  visitSelect: {
    borderRadius: '20px',
    background: Colors.WHITE_BACKGROUND,
    fontSize: '14px',
  },
  slotBtn: {
    background: '#17407B3B',
    borderRadius: '20px',
    color: Colors.TEXT_COLOR_TERTIARY,
  },
  slotBtnSelected: {
    background: Colors.BTN_BG,
  },
  dialogText: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: Colors.TEXT_COLOR_QUATERNARY,
  },
  dialogDate: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: Colors.TEXT_COLOR_MAIN,
  },
  fieldLabel: {
    fontSize: '14px',
    fontWeight: 400,
    color: Colors.TEXT_COLOR_MAIN,
  },

  formTextField: {
    fontSize: '14px',
    fontWeight: 400,
    color: Colors.TEXT_COLOR_SECONDARY,
    height: 40,
    borderRadius: '20px',
  },
  editBtn: {
    textTransform: 'capitalize',
    textDecoration: 'underline',
  },
  saveBtn: {
    textTransform: 'capitalize',
    borderRadius: '18px',
  },
})

const BookSlot = ({
  open,
  setOpen,
}: {
  open: boolean
  setOpen: (e: boolean) => void
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const [category, setCategory] = useState(
    DIALOG_CATEGORIES.PhysicalAssessmentLabTests
  )
  const [step, setStep] = useState(1)
  const [selectedPersons, setSelectedPersons] = useState(['female', 'other'])
  // eslint-disable-next-line
  const [avaliableSlots, setAvaliableSlots] = useState([
    '09:45 AM',
    '11:45 AM',
    '1:45 PM',
    '09:45 PM',
    '10:45 PM',
    '1:03 AM',
  ])
  const [selectedSlot, setSelectedSlot] = useState('')
  const [selectedSlotDate, setSelectedSlotDate] = useState<Dayjs | null>(
    dayjs('2022-04-17')
  )

  const [openPicker, setOpenPicker] = useState(false)
  const [editAddress, setEditAddress] = useState(false)

  const formik: any = useFormik({
    initialValues: {
      flatNo: '',
      street: '',
      city: '',
      state: '',
      pinCode: '',
    },
    validationSchema: Yup.object({
      flatNo: Yup.string().required('Required'),
      street: Yup.string().required('Required'),
      city: Yup.string().required('Required'),
      state: Yup.string().required('Required'),
      pinCode: Yup.string().required('Required'),
    }),
    onSubmit: (values) => {
      console.log(values)
      alert('Form submitted successfully!')
    },
  })

  const addressSection = [
    { label: 'Flat / House No., Apartment', name: 'flatNo' },
    { label: 'Colony, Street, Sector', name: 'street' },
    { label: 'City', name: 'city' },
    { label: 'State', name: 'state' },
    { label: 'Pin Code', name: 'pinCode' },
  ]

  // eslint-disable-next-line
  const handlePickerClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenPicker(!openPicker)
  }

  const handlePickerClose = () => {
    setOpenPicker(false)
  }

  const handlePersonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target
    setSelectedPersons((prevValues) =>
      checked
        ? [...prevValues, value]
        : prevValues?.filter((item) => item !== value)
    )
  }

  const handleNext = (step: number) => {
    if (step >= 3) {
      // test
    } else {
      setStep(step + 1)
    }
  }

  const RenderDialogTitle = ({ step }: { step: number }) => {
    switch (step) {
      case 1:
        return (
          <Select
            value='homeVisit'
            displayEmpty
            onChange={() => {
              console.log('test')
            }}
            size='small'
            className={classes?.visitSelect}
          >
            <MenuItem value='homeVisit'>Select Home Visit For</MenuItem>
            <MenuItem value='hospitalVisit'>Hospital Visit</MenuItem>
          </Select>
        )
      case 2:
        return <Box>Lab Tests For</Box>
      default:
        return null
    }
  }

  const RenderDialogContent = ({ step }: { step: number }) => {
    switch (step) {
      case 1:
        return (
          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-around'}
            alignItems={'center'}
          >
            <Button
              className={`${classes?.categoryBtn} ${
                category === DIALOG_CATEGORIES.PolicyExplanation
                  ? classes?.categoryBtnSelected
                  : ''
              }`}
              onClick={() => setCategory(DIALOG_CATEGORIES.PolicyExplanation)}
            >
              <Box
                className={`${classes?.categorySvgContainer} ${
                  category === DIALOG_CATEGORIES.PolicyExplanation
                    ? classes?.categorySvgContainerSelected
                    : ''
                }`}
              >
                <TieIcon />
              </Box>
              <Box>Policy Explanation</Box>
            </Button>
            <Button
              className={`${classes?.categoryBtn} ${
                category === DIALOG_CATEGORIES.PhysicalAssessmentLabTests
                  ? classes?.categoryBtnSelected
                  : ''
              }`}
              onClick={() =>
                setCategory(DIALOG_CATEGORIES.PhysicalAssessmentLabTests)
              }
            >
              <Box
                className={`${classes?.categorySvgContainer} ${
                  category === DIALOG_CATEGORIES.PhysicalAssessmentLabTests
                    ? classes?.categorySvgContainerSelected
                    : ''
                }`}
              >
                <FirstAidIcon />
              </Box>
              <Box>Physical Assessment/Lab Tests</Box>
            </Button>
          </Box>
        )
      case 2:
        return (
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            gap={2}
          >
            <Box
              display={'flex'}
              justifyContent={'start'}
              flexDirection={'column'}
              gap={0.5}
              alignItems={'center'}
            >
              <Box
                width={'100%'}
                display={'flex'}
                justifyContent={'space-between'}
              >
                <Box>Address</Box>
                <Button
                  className={classes?.editBtn}
                  color='primary'
                  onClick={() => setEditAddress(!editAddress)}
                >
                  {editAddress ? 'Save Changes' : 'Edit'}
                </Button>
              </Box>
              <Box
                border={'1px solid grey'}
                p={2}
                borderRadius={5}
                width={'100%'}
              >
                {editAddress ? (
                  <Box>
                    <Grid container spacing={2} size={{ xs: 12 }}>
                      {addressSection?.map((item, index) => (
                        <Grid
                          container
                          direction={'column'}
                          size={
                            item?.name === 'flatNo'
                              ? { xs: 12, sm: 12, lg: 12, md: 12, xl: 12 }
                              : { xs: 6, sm: 6, lg: 4, md: 4, xl: 4 }
                          }
                          spacing={1}
                          key={index}
                        >
                          <Grid size='auto'>
                            <Typography className={classes?.fieldLabel}>
                              {item?.label}
                            </Typography>
                          </Grid>
                          <Grid size='auto'>
                            <TextField
                              name={item?.name}
                              value={formik?.values?.[item?.name]}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik?.touched?.[item?.name] &&
                                Boolean(formik.errors?.[item?.name])
                              }
                              helperText={
                                formik.touched?.[item?.name] &&
                                formik.errors?.[item?.name]
                              }
                              slotProps={{
                                input: {
                                  className: classes?.formTextField,
                                },
                              }}
                              fullWidth
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                ) : (
                  <Box>
                    Hno.289, Sai sindhu residency, Ambedkar Nagar, Amlapuram,
                    42020
                  </Box>
                )}
              </Box>
            </Box>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              width={'100%'}
              pl={1}
              pr={1}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedPersons.includes('female')}
                    onChange={handlePersonChange}
                    value='female'
                  />
                }
                label={
                  <>
                    <Box>Joel Mihavel</Box>
                    <Box>49 years</Box>
                  </>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedPersons.includes('male')}
                    onChange={handlePersonChange}
                    value='male'
                  />
                }
                label={
                  <>
                    <Box>Marina</Box>
                    <Box>40 years</Box>
                  </>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedPersons.includes('other')}
                    onChange={handlePersonChange}
                    value='other'
                  />
                }
                label={
                  <>
                    <Box>Rahul</Box>
                    <Box>49 years</Box>
                  </>
                }
              />
            </Box>
            <Box
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'center'}
              gap={1}
              color={Colors.ERROR_COLOR}
            >
              <InfoOutlinedIcon />
              $Rahul doesn&#39;t require lab test
            </Box>
          </Box>
        )
      case 3:
        return (
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'start'}
            gap={4}
          >
            <Box>
              <span className={classes?.dialogText}>Select Date -</span>{' '}
              <span className={classes?.dialogDate}>
                {selectedSlotDate
                  ? selectedSlotDate.format('DD-MM-YYYY')
                  : 'No Date Selected'}
                <IconButton
                  onClick={handlePickerClick}
                  color='primary'
                  size='small'
                >
                  <EditIcon fontSize='small' />
                </IconButton>
              </span>
            </Box>
            {openPicker ? (
              <Box width={'100%'}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateCalendar
                    value={selectedSlotDate}
                    onChange={(newValue) => {
                      setSelectedSlotDate(newValue)
                      handlePickerClose()
                    }}
                  />
                </LocalizationProvider>
              </Box>
            ) : (
              <Box
                display={'flex'}
                justifyContent={'start'}
                gap={2}
                flexWrap={'wrap'}
              >
                {avaliableSlots?.map((item, index) => {
                  return (
                    <Button
                      key={index}
                      variant='contained'
                      className={`${classes?.slotBtn} ${
                        selectedSlot === item ? classes?.slotBtnSelected : ''
                      }`}
                      size='small'
                      onClick={() => setSelectedSlot(item)}
                    >
                      {item}
                    </Button>
                  )
                })}
              </Box>
            )}
          </Box>
        )
      default:
        return null
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: Colors.MODAL_BG,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogTitle
        id='customized-dialog-title'
        variant='h6'
        paddingBottom={'unset !important'}
      >
        <RenderDialogTitle step={step} />
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={() => setOpen(false)}
        className={classes?.dialogCloseBtn}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <RenderDialogContent step={step} />
      </DialogContent>
      <DialogActions className={classes?.dialogActions}>
        <Button
          variant='contained'
          className={classes?.actionBtn}
          onClick={() => handleNext(step)}
        >
          {step === 3 ? 'Shedule Visit' : 'Next'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default BookSlot
